/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';

import Stack from '@mui/material/Stack';
import { status } from 'venuescanner-js/constants/thread';
import { isOrganiser } from 'venuescanner-js/constants/user_type';
import CheckboxWithLabel from 'venuescanner-js/react/components/Form/CheckboxWithLabel';
import Tooltip from 'venuescanner-js/react/components/Tooltip';
import Button from '@mui/material/Button';

const CtaMarkAsBooked = ({ thread, onClick, type, variant = 'outlined' }) => {
  const { isMobileDevice } = useContext(ViewContext);
  const [checked, setChecked] = useState(false);

  if (type === 'button') {
    return (
      <Button
        fullWidth
        variant={variant}
        color='primary'
        size='medium-large'
        onClick={onClick}>
        Mark as booked
      </Button>
    );
  }

  const prompt = getProps(thread, isOrganiser(thread));

  const handleChange = event => {
    setChecked(event.target.checked);
    onClick();
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='start'
      spacing={1.25}>
      <CheckboxWithLabel
        checked={checked}
        label={prompt}
        onChange={handleChange}
      />
      {isOrganiser(thread) && !isMobileDevice && (
        <Tooltip
          title={`Have you booked this venue for your event? Click "${prompt}"
                    to let us know, and we'll then plant a tree on your behalf as
                part of our efforts to help give something back.`}
        />
      )}
    </Stack>
  );
};

const getProps = (thread, isOrganiser) => {
  if (!thread) return '';
  const threadStatus = thread.status;

  if (isOrganiser) {
    return 'I have booked this venue';
  }

  return threadStatus === status.BOOKED_BY_ORG
    ? `${
        thread._organiser?.name || 'Organiser'
      } has marked this enquiry as booked, please tick to confirm.`
    : 'Mark as booked';
};

export default CtaMarkAsBooked;
